const ucFirst=string=>{if(string===undefined)return string;return string[0].toUpperCase()+string.slice(1).toLowerCase();};export default ucFirst;